<template>
	<div class="Modal">
		<div class="header">
			<div class="button">NIEUWE SUPPORT TICKET AANMAKEN</div>
		</div>
		<div class="body">
			<div class="details">
				<div class="detail-item-header">SUPPORT</div>
				<div class="detail-row">
					<div class="detail-item-column">
						<div class="detail-item-row">
							<div class="item-row-key">{{ project.company.companyname }}</div>
							<div>{{ project.company.customernumber }}</div>
						</div>
					</div>
					<div class="detail-item-column">
						<div class="detail-item-row">
							<div class="item-row-key">{{ project.name }}</div>
							<div>{{ project.number }}</div>
						</div>
					</div>
				</div>
				<div class="detail-columns">
					<div class="detail-item-column">
						<div class="detail-item-header">ADVIESGESPREK</div>
						<div class="detail-item-row">
							<div class="item-row-key">Bezocht</div>
							<div>{{ parseDate(project.company.customfield_afspraakdatum) }}</div>
						</div>
						<div class="detail-item-row">
							<div class="item-row-key">Tijdstip</div>
							<div>{{
									getTime(project.company.customfield_afspraaktijdstip,
										project.company.customfield_afspraakwoningtype === 'vrijstaande-woning' ? '1.25' : '1')
								}}
							</div>
						</div>
						<div class="detail-item-row">
							<div class="item-row-key">Accountmanager</div>
							<div>{{ project.company.agent != null ? project.company.agent.display_name : "Onbekend" }}</div>
						</div>
					</div>
					<div class="detail-item-column" v-if="appointment">
						<div class="detail-item-header">UITVOERING</div>
						<div class="detail-item-row">
							<div class="item-row-key">Datum</div>
							<div>{{ parseDate(project.customfield_uitvoeringdatum) }}</div>
						</div>
						<div class="detail-item-row">
							<div class="item-row-key">Tijdstip</div>
							<div>{{ project.customfield_begintijduitvoering2 }} -
								{{ project.customfield_eindtijduitvoering2 }}
							</div>
						</div>
						<div class="detail-item-row">
							<div class="item-row-key">Ploeg</div>
							<div>{{ appointment.teamLeader.display_name }}</div>
						</div>
						<div class="detail-item-row">
							<div class="item-row-key">Medewerkers</div>
							<div class="items">
								<div v-for="member in appointment.teamMembers">
									{{ member.display_name }}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="detail-row">
					<div class="detail-item-column">
						<textarea disabled class="TextField">{{ project.company.customfield_opmerkingafspraak }}</textarea>
					</div>
					<div class="detail-item-column">
						<textarea disabled class="TextField">{{ appointment && appointment.answer != null ? appointment.answer.text_value : "" }}</textarea>
					</div>
				</div>
			</div>
			<div class="pictures">
				<div v-for="index in 4" class="upload-wrapper">
					<QuestionSingleFileUpload type="support/support" ref="fileUploads" :company-id="project.company.id" accept="image/*"></QuestionSingleFileUpload>
				</div>
			</div>
			<form method="POST" action="/" @submit.prevent="onSubmitForm">
				<div class="detail-columns">
					<div class="detail-item-column">
						<div class="detail-item-row">
							<select name="support-reason-select" v-model="formData.support_reason">
								<option :value="null" disabled selected>Reden van de support-ticket</option>
								<option v-for="reason in reasons" :key="reason" :value="reason">{{ reason }}</option>
							</select>
						</div>
						<span class="error" v-if="errors.includes('support_reason')">Selecteer een waarde</span>
						<div class="detail-item-row">
							<input name="support-email" v-model="formData.email" />
							<ToggleField type="checkbox" :value="true" :un-checked-value="false" v-model="formData.send_photo_link"/>
						</div>
						<div class="detail-item-row" @click="formData.inspection_with_customer = !formData.inspection_with_customer">
							<div>Is er bij oplevering een rondje met de klant gelopen?</div>
							<ToggleField :checked="formData.inspection_with_customer" type="checkbox"
										 name="inspectionWithCustomer"></ToggleField>
						</div>
						<div class="detail-item-row" @click="formData.invoice_on_hold = !formData.invoice_on_hold">
							<span>Factuur op ON-HOLD zetten</span>
							<ToggleField :checked="formData.invoice_on_hold" type="checkbox"
										 name="invoiceOnHold"></ToggleField>
						</div>
					</div>
					<div class="detail-item-column">
						<textarea class="TextField" name="description" v-model="formData.description"
								  placeholder="Omschrijving van de support ticket"></textarea>
						<span class="error" v-if="errors.includes('description')">Vul een waarde in</span>
						<div class="detail-item-row">
							<div>Bron ticket</div>
							<select class="source-select" name="source-select" v-model="formData.source">
								<option value="email">E-mail</option>
								<option value="post">Post</option>
								<option value="telefoon">Telefoon</option>
								<option value="accountmanager" selected>Accountmanager</option>
								<option value="kwaliteitscontrole">Kwaliteitscontrole</option>
							</select>
						</div>
						<span class="error" v-if="errors.includes('source')">Vul een waarde in</span>
					</div>
				</div>
				<div class="footer">
					<Button class="button" type="submit" ref="submitButton">OPSLAAN</Button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import Button from "@/components/Button";
import ToggleField from "@/components/ToggleField";
import {mapMutations, mapState} from "vuex";
import { parseDate, calculatePlanningAppointmentEndTime } from "../utils";
import { validateNotEmptyOrEmptyString } from "../common/validators";
import { PlusIcon } from "vue-feather-icons";
import { client } from "../store";
import QuestionSingleFileUpload from "./QuestionSingleFileUpload.vue";

export default {
	name: "CreateSupportTicketModal",

	components: {
		QuestionSingleFileUpload,
		ToggleField,
		Button,
		PlusIcon
	},

	props: {
		project: Object,
	},

	data() {
		return {
			appointment: null,
			formData: {
				support_reason: null,
				description: "",
				invoice_on_hold: true,
				email: "",
				send_photo_link: true,
				source: "accountmanager",
				inspection_with_customer: false
			},
			formValidators: {
				support_reason: validateNotEmptyOrEmptyString,
				description: validateNotEmptyOrEmptyString,
				source: validateNotEmptyOrEmptyString
			},
			errors: [],
			reasons: [],
			reasonsSpouwmuur: [
				"Boorgaten vergeten te dichten",
				"Met verkeerde kleur gevoegd",
				"Troep achter gelaten",
				"Resten van het product zichtbaar",
				"Muur/kozijn ontzet",
				"Vochtplekken ontstaan",
				"Niet voldoende isolatiemateriaal aangebracht",
				"Schade aangebracht door hoogwerker",
				"Schade aangebracht door ons",
				"Nog ventilatieroosters plaatsen",
				"Anders"
			],
			reasonsVloerisolatie: [
				"Bodemfolie niet goed bevestigt",
				"Gedeelte niet geïsoleerd",
				"Geen bodemfolie gelegd",
				"Kruipluik niet geïsoleerd",
				"Materiaal aan zijkanten niet luchtdicht",
				"Materiaal hangt los",
				"Roosters boven het isolatiemateriaal",
				"Schade ontstaan aan leidingen of kabels",
				"Anders"
			],
			reasonsBodemisolatie: [
				"Te weinig materiaal ingespoten",
				"Anders"
			]
		}
	},

	methods: {
		...mapMutations({
			removeProjectMarker: 'projects/removeProjectMarker'
		}),

		onSubmitForm() {
			const button = this.$refs.submitButton;
			button.disable();

			this.validateFields();

			if (this.errors.length > 0) {
				button.enable();
				return;
			}

			Promise.all(this.$refs.fileUploads.map(fileUpload => fileUpload.uploadFiles())).then(() => {
				return new Promise((resolve, reject) => {
					this.createSupportTicket().then(() => {
						resolve();
					}).catch((error) => {
						reject(error);
					});
				});
			}).then(() => {
				button.enable();
				this.$notify({
					group: "app",
					title: "Support ticket maken",
					type: "success",
					text: `Support ticket aangemaakt voor ${this.project.company.companyname}`
				});

				this.removeProjectMarker(this.project.id);
				this.$events.emit("map/closePopup");
				this.$emit("close");
			}).catch((error) => {
				console.error(error);
				button.enable();
				this.$notify({
					group: "app",
					title: "Support ticket maken",
					type: "error",
					text: `Support ticket aanmaken mislukt voor ${this.project.company.companyname}`
				});
			});
		},

		createSupportTicket() {
			const query = `
				mutation ($project_id: ID!, $appointment_id: ID, $support_reason: String!, $description: String!, $invoice_on_hold: Boolean!, $send_photo_link: Boolean!, $email: String!, $source: String!, $inspection_with_customer: Boolean!) {
					createSupportTicket(project_id: $project_id, appointment_id: $appointment_id, support_reason: $support_reason, description: $description, invoice_on_hold: $invoice_on_hold, send_photo_link: $send_photo_link, email: $email, source: $source, inspection_with_customer: $inspection_with_customer)
				}
			`;

			return new Promise((resolve, reject) => {
				const postData = {
					project_id: this.project.id,
					...this.formData
				};

				if (this.appointment != null) {
					postData.appointment_id = this.appointment.id;
				}

				client.query(query, postData).then(result => {
					if(result.errors != null && result.errors.length > 0) {
						reject(result.errors);
						return;
					}
					resolve(result);
				}).catch((error) => {
					reject(error);
				});
			});
		},

		getAppointmentAnswers(appointment_id) {
			const query = `
				query ($id: Int!) {
					appointmentById(id: $id) {
						id,
						answers(question_constants: ["AndereOpmerkingen"]) {
							text_value
						}
					}
				}
			`;

			client.query(query, {
				id: appointment_id,
				types: ["AndereOpmerkingen"]
			}).then((result) => {
				this.appointment.answer = result.appointmentById.answers[0];
			})
		},

		validateFields() {
			for (const [field, validationResult] of Object.entries(this.formValidators)) {
				const value = this.formData[field];
				validationResult(value) !== true ? this.errors.push(field) : this.removeFormErrors(field);
			}
		},

		removeFormErrors(value) {
			this.errors = this.errors.filter(error => error !== value);
		},

		parseDate(date) {
			return parseDate(date);
		},

		empty(value) {
			return value == null || (typeof value === "string" && value.trim() === "");
		},

		getTime(time, durationHours) {
			return calculatePlanningAppointmentEndTime(time, durationHours);
		},
	},

	computed: {
		...mapState({
			isLoading: "loading"
		})
	},

	beforeMount() {
		if (this.project.appointments.length > 0) {
			this.appointment = this.project.appointments.find(a => a.type === "PROJECT/UITVOERENDE_PLOEG");
			this.getAppointmentAnswers(this.appointment.id);
		}
		this.formData.email = this.project.company.email;

		switch (this.project.additionalData.project_type) {
			default:
			case "SPOUWMUURISOLATIE":
				this.reasons = this.reasonsSpouwmuur;
				break;
			case "BODEMISOLATIE":
				this.reasons = this.reasonsBodemisolatie;
				break;
			case "VLOERISOLATIE":
				this.reasons = this.reasonsVloerisolatie;
				break;
		}
	}
}
</script>

<style scoped>
.Modal {
	padding: 28px 24px;
	font-size: 17px;
}

.header {
	border-bottom: 2px solid #d2d2d2;
	padding-bottom: 28px;
	margin-bottom: 24px;
}

.button {
	text-align: center;
	padding: 8px 12px;
	background-color: #35a5a4;
	color: white;
	border: none;
	border-radius: 4px;
	font-size: 1em;
	display: inline;
	font-weight: 425;
}

.details {
	border-bottom: 2px solid #d2d2d2;
	padding-bottom: 24px;
}

.details > .detail-row {
	display: flex;
	gap: 24px;
	margin-bottom: 24px;
}

.details > .detail-row ~ .detail-row {
	margin: 0;
}

.detail-item-column {
	display: flex;
	flex-direction: column;
	gap: 8px;
	width: 50%;
}

.detail-item-column > .detail-item-header {
	margin-bottom: -4px;
}

.detail-item-row {
	justify-content: space-between;
	display: flex;
	gap: 18px;
	align-items: center;
}

form > .detail-columns > .detail-item-column > .detail-item-row {
	min-height: 39px;
}

.detail-item-header {
	color: #35a5a4;
	font-weight: 800;
	margin-bottom: 10px;
}

.details > .detail-item-header {
	padding-left: 5px;
	border-left: 3px solid #35a5a4;
}

.detail-columns {
	display: flex;
	gap: 24px;
	margin-bottom: 24px;
}

.items {
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	gap: 5px;
}

.detail-item-column textarea {
	margin: 0;
	width: 100%;
	height: 100%;
	border: 1px solid #aaa;
	border-radius: 4px;
	color: #666;
	background-color: #fff;
}

.pictures {
	display: flex;
	justify-content: space-between;
	gap: 24px;
	margin-top: 24px;
	margin-bottom: 24px;
}

.pictures .upload-wrapper {
	width: 25%;
	aspect-ratio: 16/9;
}

.footer {
	display: flex;
	justify-content: flex-end;
}

select, input {
	width: 100%;
	border: 1px solid #aaa;
	background-color: #fff;
	border-radius: 4px;
	padding: 10px 5px;
}

.source-select {
	width: 60%;
}

.error {
	color: red;
}
</style>
